import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;
const service = 'jernyonboarding';

class OnboardingService extends ServiceBase {
    abort = (jwt) => {
        const url = `${baseUrl}/${service}/newuser/abort`;
        const config = {
            headers: { Authorization: `Bearer ${jwt}` },
        };

        return agent.post(url, {}, config);
    };

    cancel = (jwt) => {
        const url = `${baseUrl}/${service}/newuser/cancel`;
        const config = {
            headers: { Authorization: `Bearer ${jwt}` },
        };

        return agent.post(url, {}, config);
    };

    /**
     * get state of pending user
     *
     * @param {string} uid
     * @param {string} jwt - Clerk JWT token
     * @returns
     */
    getStatus = (uid, jwt) => {
        const url = `${baseUrl}/${service}/newuser/status?uid=${uid}`;

        const config = {
            headers: { Authorization: `Bearer ${jwt}` },
        };

        return agent.get(url, config);
    };

    /**
     * Set the selected tier after Clerk signup
     * @param {string} tier - selected tier (free | standard)
     * @param {string} jwt - Clerk JWT token
     * @returns {Promise} response with checkoutUrl (standard) or empty (free)
     */
    setTier = (tier, jwt) => {
        const url = `${baseUrl}/${service}/newuser/settier`;

        const config = {
            headers: {
                Authorization: `Bearer ${jwt}`,
                'Content-Type': 'application/json',
                'X-Jerny-Tier': tier,
            },
        };

        return agent.post(url, { tier }, config);
    };

    /**
     * Update onboarding state for audit trail
     * @param {string} uid
     * @param {number} stateId
     * @param {string} jwt
     * @returns
     */
    updateState = (uid, stateId, jwt) => {
        const url = `${baseUrl}/${service}/newuser/updatestate`;

        const config = {
            headers: {
                Authorization: `Bearer ${jwt}`,
                'Content-Type': 'application/json',
            },
        };

        return agent.post(url, { uid, stateId }, config);
    };

    /**
     * Ensure pending user exists in backend — called on recovery when backend missed initial setTier.
     * Creates user with given tier if not found, no Stripe, no mail.
     * @param {string} uid - Clerk user id
     * @param {string} tier - selected tier (free | standard)
     * @param {string} jwt - Clerk JWT token
     * @returns {Promise}
     */
    ensureUser = (uid, tier, stateId, apiKey, jwt) => {
        const url = `${baseUrl}/${service}/newuser/ensureUser`;

        const config = {
            headers: {
                Authorization: `Bearer ${jwt}`,
                'Content-Type': 'application/json',
                'X-Jerny-Tier': tier,
            },
        };

        return agent.post(url, { uid, stateId, apiKey }, config);
    };
}

const onboardingService = new OnboardingService();
export default onboardingService;
